<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
		<vx-tooltip text="Categories" position="bottom" class="mr-4 inline-block">
			<feather-icon icon="LinkIcon"
				:svgClasses="`h-5 w-5 ${!permissionCheck($route.name, 'edit') || params.data.deleted_at != null ? 'cursor-not-allowed opacity-50' : 'hover:text-primary cursor-pointer'}`"
				@click="updatePrompt()"/>
		</vx-tooltip>
			
		<vx-tooltip v-if="params.data.deleted_at == null" text="Deactivate" position="bottom" class="inline-block">
			<feather-icon icon="Trash2Icon"
				:svgClasses="`h-5 w-5 ${!permissionCheck($route.name, 'delete') ? 'cursor-not-allowed opacity-50' : 'hover:text-danger cursor-pointer'}`"
				@click="confirmDelete()"/>
		</vx-tooltip>
		<vx-tooltip v-else text="Activate" position="bottom" class="inline-block">
			<feather-icon icon="RotateCcwIcon"
				:svgClasses="`h-5 w-5 ${!permissionCheck($route.name, 'delete') ? 'cursor-not-allowed opacity-50' : 'hover:text-success cursor-pointer'}`"
				@click="confirmDelete()"/>
		</vx-tooltip>

		<vs-prompt id="categories-prompt" class="con-vs-dialog--large" title="Update Linked Categories" @cancel="prePopulateCategories" @close="prePopulateCategories" @accept="updateRecord" :active.sync="categories['prompt']">
			<v-select class="w-full" v-model="categories['value']" multiple :options="categoriesOptions" :clearable="false"></v-select>
		</vs-prompt>
	</div>
</template>

<script>
    import vSelect from 'vue-select'

	export default {
		name: 'CellRendererActions',
		components: {
			'v-select': vSelect
		},
		data() {
			return {
				categories: {
					value: null,
					prompt: false
				},
			}
		},
		computed: {
            categoriesMaster() {
                return this.$store.state.categoriesMaster;
			},
			categoriesOptions: function() {
				let selectedCategories = [];

				this.params.node.parent.allLeafChildren.forEach(element => {
					selectedCategories.push(...element['data']['categories'].map(y => y['id']));
				});

				const availableCategories = this.categoriesMaster.filter(x => !selectedCategories.includes(x['id']));

				const formattedArray = availableCategories.map(x => {
					return {
						label: x['name'],
						value: x['id']
					}
				});

				return [...formattedArray, ...this.params.data.categories.map(x => {
					return {
						label: x['name'],
						value: x['id']
					}
				})];
			}
		},
		methods: {
			prePopulateCategories() {
				// Prefill row's categories
				this.categories['value'] = this.params.data.categories.map(x => {
					return {
						label: x['name'],
						value: x['id']
					}
				});
			},
            confirmDelete() {
				if(this.permissionCheck(this.$route.name, 'delete')) {
					if (this.params.data.deleted_at == null) {
						this.$vs.dialog({
							type: 'confirm',
							color: 'danger',
							title: 'Confirm Status Change',
							text: `Do you want to deactivate "${this.params.data.parent_name}"?`,
							accept: this.deleteRecord,
							parameters: 'deactivate',
							acceptText: 'Deactivate'
						})
					}
					else {
						this.$vs.dialog({
							type: 'confirm',
							color: 'success',
							title: 'Confirm Status Change',
							text: `Do you want to activate "${this.params.data.parent_name}"?`,
							accept: this.deleteRecord,
							parameters: 'activate',
							acceptText: 'Activate'
						})
					}
				}
			},
            showDeleteSuccess(flag) {
				if (flag == 'activate') {
					this.$vs.notify({
						color: 'success',
						title: 'Parent Category Activated',
						text: 'The selected parent category was successfully activated'
					})
				}
				else {
					this.$vs.notify({
						color: 'success',
						title: 'Parent Category Deactivated',
						text: 'The selected parent category was successfully deactivated'
					})
				}
            },
            deleteRecord(flag) {
                this.$axiosSecure.delete(`/parent-categories/${this.params.data.parent_id}`, {
						params: {
							'action': flag
						}
					})
                    .then(() => {
                        this.$root.$emit('refreshPage');

                        this.showDeleteSuccess(flag);
                    })
                    .catch(error => {
                        // Error notification
                        if (error.response.status == 401) {
                            this.$vs.notify({
                                color: 'danger',
                                title: `Not authorized`,
                                text: `You do not have permission to access the resource`
                            });
                        } else if (error.response.status == 403) {
                            // Token invalid so logout
                            this.$root.$emit('appLogout');
                        } else {
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Something went wrong',
                                text: 'Please contact the server admin'
                            });
                        }
                        // eslint-disable-next-line no-console
                        console.log(error);
                    })

            },
            updatePrompt(flag) {
                if(this.permissionCheck(this.$route.name, 'edit') && this.params.data.deleted_at == null) {
                    this.categories['prompt'] = true;
                }
            },
            updateRecord() {
				this.$axiosSecure.patch(`/parent-categories/${this.params.data.parent_id}`, {
						'categories': this.categories['value'].map(x => x['value'])
					})
					.then(() => {
						this.$root.$emit('refreshPage');

						this.showUpdateRecordSuccess();
					})
					.catch(error => {
						// Error notification
						if (error.response.status == 401) {
							this.$vs.notify({
								color: 'danger',
								title: `Not authorized`,
								text: `You do not have permission to access the resource`
							});
						}
						else if (error.response.status == 403) {
							// Token invalid so logout
							this.$root.$emit('appLogout');
						}
						else {
							this.$vs.notify({
								color: 'danger',
								title: 'Something went wrong',
								text: 'Please contact the server admin'
							});
						}
						// eslint-disable-next-line no-console
						console.log(error);
					})
            },
			showUpdateRecordSuccess() {
				this.$vs.notify({
					color: 'success',
					title: 'Parent Category Updated',
					text: 'The linked categories was successfully updated'
				})
			},
		},
		beforeMount() {
			// Prefill row's categories
			this.prePopulateCategories();
		}
	}
</script>
